import SetPassword from "@auth/pages/set-password";
import { createFileRoute } from "@tanstack/react-router";

interface SetPasswordSearch {
  token?: string;
}

export const Route = createFileRoute(
  "/(auth)/(headless)/(distributor)/set-password"
)({
  component: SetPasswordRoute,
  validateSearch: (search: Record<string, unknown>): SetPasswordSearch => {
    const rawToken = search.token;
    return {
      token:
        typeof rawToken === "string" && rawToken.trim().length > 0
          ? rawToken
          : undefined,
    };
  },
});

function SetPasswordRoute() {
  const { token } = Route.useSearch();
  return <SetPassword verificationToken={token ?? ""} />;
}
